<template>
  <div class="app-form-container">
    <div class="app-form-control" :class="{ focus: focused }">
      <!--    <label class="app-input-label" :for="_uid" v-if="label">{{ label }}</label>-->
      <div class="middle" @click="onfocus" ref="middle">
        <label
            v-if="placeholder"
            class="form-placeholder"
            :class="{ focused: focused, active: focused }"
        >{{ placeholder }}</label>
        <div style="display: flex" v-if="focused === true">

          <div class="slot pre" v-if="prefix">
            {{ prefix}}
          </div>
          <input
              ref="inputVal"
              :id="id"
              class="input"
              :value="value"
              @input="$emit('input', $event.target.value)"
              @change="change"
              @focus="onfocus"
              @blur="onblur"
              :disabled="disabled"
              :type="type"
          />
          <div class="slot append"  v-if="suffix">
            {{suffix}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {inputProps} from "../../../props";
import {format, unformat} from "../../../plugins/currency-input/utils";

export default {
  props: inputProps,
  data() {
    return {
      formattedValue: '',
      moneyOptions: {
        decimal: this.decimal,
        precision: this.precision,
        thousands: this.thousands,
        prefix: this.prefix,
        suffix: this.suffix,
      },
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          if (this.currency) {
            this.formattedValue = format(newValue, this.moneyOptions)
          }
          this.$emit('input', newValue)
        }
      },
    },
  },
  mounted() {
    this.$refs.middle.addEventListener("click", () => {
      this.$refs.inputVal.focus();
    });
  },
  beforeDestroy() {
    this.$refs.middle.removeEventListener("click", () => {
      this.$refs.inputVal.focus();
    });
  },
  methods: {
    change(e) {
      this.$emit(
          'change',
          this.currency
              ? unformat(e.target.value, this.moneyOptions.precision)
              : e.target.value
      )
    },
    onfocus() {
      this.focused = true
      this.v.$reset()
    },
    onblur() {
      if(this.value === null || this.value === '') {
        this.focused = false
        this.v.$touch()
      }
    },
  },
}

</script>

<style lang="scss" src="./AppInput.scss" />